import React, { useState } from 'react';
import { Breadcrumb } from 'components';
import {
  Card,
  Typography,
  Tabs,
  Tab
} from '@material-ui/core';
import DNSManualSetup from './DNSManualSetup';
import DNSEmailForm from './DNSEmailForm';


const DNSSettings = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleChangeTab = (event, newValue) => setTabValue(newValue);

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'Go Live Requirements', path: '/settings#go_live_requirements' },
            { name: 'Connect Your Store Domain' }
          ]}
        />
      </div>
      <div className="m-10">
        <Typography variant="h3" className="mb-4 text-dark-gray">
          Install DNS Records
        </Typography>
        <Typography variant="h6" className="mb-8 text-dark-gray">
          You will need to install the following records to connect your online store.
        </Typography>
        <Card className="p-8">
          <Tabs
            value={tabValue}
            onChange={handleChangeTab}
            textColor="primary"
            indicatorColor="primary"
            aria-label="secondary tabs"
            className="mb-8"
          >
            <Tab
              label="Manual Setup"
              value={0}
              className="capitalize font-bold flex items-center px-4"
            />
            <Tab
              label="Send To A Coworker"
              value={1}
              className="capitalize font-bold flex items-center px-4"
            />
          </Tabs>
          {tabValue === 0 && <DNSManualSetup />}
          {tabValue === 1 && <DNSEmailForm />}
        </Card>
      </div>
    </div>
  );
};

export default DNSSettings;
